import { useEffect, useState } from "react";
import useAxiosInstance from "../../../../../Utilities/Hooks/useAxiosInstance";
import Form from "../../../../Partials/Layouts/Forms/Form";
import ShortTextInput from "../../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput";
import FormSubmitButton from "../../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton";
import {
  BRANDS_API,
  CATAGORY_API,
  PRODUCTS_API,
  DISCOUNTS_API,
  PARTNERS_API,
  SIZEGUIRDES,
} from "../../../../../Utilities/APIs/APIs";
import SwitchInput from "../../../../Partials/Layouts/Forms/FormInputs/SwitchInput/SwitchInput";
import ImageInput from "../../../../Partials/Layouts/Forms/FormInputs/ImageInput/ImageInput";
import SelectInput from "../../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectInput";
import SelectOption from "../../../../Partials/Layouts/Forms/FormInputs/SelectInput/SelectOption/SelectOption";

import slugify from "react-slugify";
import NumberInput from "../../../../Partials/Layouts/Forms/FormInputs/NumberInput/NumberInput";
import CustomEditor from '../../../../Partials/Elements/CustomEditor/CustomEditor';

function UpdateProduct({ targetID, triggerFetch, setShowUpdateForm }) {
  const axiosInstance = useAxiosInstance();

  const [category, setCategory] = useState("");
  const [brand, setBrand] = useState("");
  const [name, setName] = useState("");
  const [keywords, setKeywords] = useState("");
  const [skuId, setSkuId] = useState("");
  const [price, setPrice] = useState("");
  const [gender, setGender] = useState("");
  const [description, setDescription] = useState("");
  const [details, setDetails] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [cardFrontImage, setCardFrontImage] = useState("");
  const [cardHoverImage, setCardHoverImage] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [trialStatus, setTrialStatus] = useState(false);
  const [isDiscount, setIsDiscount] = useState(false);
  const [discount, setDiscount] = useState("");
  const [partner, setPartner] = useState("");
  const [isPreOrder, setIsPreOrder] = useState(false);
  const [isReStocked, setIsReStocked] = useState(false);
  const [partners, setPartners] = useState(null);
  const [discounts, setDiscounts] = useState(null);
  const [brands, setBrands] = useState(null);
  const [catagories, setCatagories] = useState(null);
  const [precedence, setPrecedence] = useState(0);
  const [singleDiscount, setSingleDiscount] = useState(null);
  const [sizeGuide, setSizeGuide] = useState('');
  const [productGroup, setProductGroup] = useState("");
  const [productColorName, setProductColorName] = useState("");
  const [productColorHex, setProductColorHex] = useState("");

  const currentPrice =
    isDiscount && singleDiscount
      ? parseInt(price - (price * singleDiscount.percentage) / 100)
      : parseInt(price);

      const [sizeGuides, setSizeGuides] = useState(null);



  useEffect(() => {
    async function fetchAndSetSingleProduct() {
      const { data } = await axiosInstance.get(
        PRODUCTS_API + "getSingleProduct/" + targetID
      );
      setCategory(data?.category?._id);
      setBrand(data?.brand?._id);
      setName(data?.name);
      setKeywords(data?.keywords);
      setProductGroup(data?.productGroup || "");
      setProductColorName(data?.productColorName || "");
      setProductColorHex(data?.productColorHex || "");
      setSkuId(data?.squId);
      setPrice(data?.price);
      setGender(data?.gender);
      setDescription(data.description);
      setDetails(data.details);
      setIsVisible(data?.isVisible);
      setIsPreOrder(data?.isPreOrder);
      setCardFrontImage(data?.cardFrontImage);
      setCardHoverImage(data?.cardHoverImage);
      setMetaTitle(data?.metaTitle);
      setMetaDescription(data?.metaDescription);
      setTrialStatus(data?.trialStatus);
      setIsDiscount(data?.isDiscount);
      setDiscount(data?.discount?._id);
      setPartner(data?.partner?._id);
      setSizeGuide(data?.sizeGuide)
      setPrecedence(data?.precedence)
      setIsReStocked(data?.isReStocked)
    }
    fetchAndSetSingleProduct();
  }, [targetID, axiosInstance]);

  useEffect(() => {
    if (gender) {
      async function fetchAndSetCatagories() {
        const { data } = await axiosInstance.get(
          CATAGORY_API + "getCategoryByGender/" + gender
        );
        setCatagories(data);
      }
      fetchAndSetCatagories();
    }

    async function fetchAndSetBrands() {
      const { data } = await axiosInstance.get(BRANDS_API);
      setBrands(data);
    }
    fetchAndSetBrands();

    async function fetchAndSetDiscounts() {
      const { data } = await axiosInstance.get(DISCOUNTS_API);
      setDiscounts(data);
    }
    fetchAndSetDiscounts();

    async function fetchAndSetPartners() {
      const { data } = await axiosInstance.get(PARTNERS_API);
      setPartners(data);
    }
    fetchAndSetPartners();
  }, [axiosInstance, gender]);

  useEffect(() => {
    if (discount) {
      async function fetchAndSetSingleDiscount() {
        const { data } = await axiosInstance.get(
          DISCOUNTS_API + "getSingleDiscount/" + discount
        );
        setSingleDiscount(data);
      }
      fetchAndSetSingleDiscount();
    }
  }, [discount, axiosInstance]);

  useEffect(() => {
    async function fetchAndSetGuideSize() {
      const { data } = await axiosInstance.get(SIZEGUIRDES + 'getSizeGuides');
      setSizeGuides(data);

    }
    fetchAndSetGuideSize();
  }, [axiosInstance]);

  async function handleSubmit(e) {
    e.preventDefault();
    const itemData = new FormData();

    itemData.append("category", category);
    if (brand && brand !== "") itemData.append("brand", brand);
    itemData.append("name", name);
    itemData.append("keywords", keywords);
    if (skuId && skuId !== "") itemData.append("squId", skuId);
    itemData.append("price", price);
    itemData.append("slug", slugify(name));
    itemData.append("productGroup", productGroup.trim());
    itemData.append("productColorName", productColorName.trim());
    itemData.append("productColorHex", productColorHex.trim());
    itemData.append("gender", gender);
    itemData.append("description", description);
    itemData.append("details", details);
    itemData.append("isVisible", isVisible);
    itemData.append("isPreOrder", isPreOrder);
    itemData.append("isReStocked", isReStocked);
    itemData.append("cardFrontImage", cardFrontImage);
    itemData.append("cardHoverImage", cardHoverImage);
    itemData.append("metaTitle", metaTitle);
    itemData.append("metaDescription", metaDescription);
    itemData.append("trialStatus", trialStatus);
    itemData.append("isDiscount", isDiscount);
    itemData.append("currentPrice", currentPrice);
    itemData.append("precedence", precedence);
    if (sizeGuide && sizeGuide !== "") itemData.append("sizeGuide", sizeGuide);
    if (discount && discount !== "") itemData.append("discount", discount);
    if (partner && partner !== "") itemData.append("partner", partner);

    const response = await axiosInstance.patch(
      PRODUCTS_API + targetID,
      itemData
    );
    if (response) {
      triggerFetch();
      setShowUpdateForm(false);
    }
  }

const [sizeGuideSearchTerm, setSizeGuideSearchTerm] = useState("");
const filteredSizeGuides = sizeGuides?.filter((sg) =>
  sg.name.toLowerCase().includes(sizeGuideSearchTerm.toLowerCase())
);

  return (
    <div className="crate_form">
      <Form onSubmit={handleSubmit}>
        <div>
          <ShortTextInput
            label={`SkuID`}
            value={skuId}
            placeholder={`SkuID`}
            setState={setSkuId}
          />
          <SelectInput label={"Gender"} value={gender} setState={setGender}>
            <SelectOption optionValue="" optionText="Select Gender" />
            <SelectOption optionValue="men" optionText="Men" />
            <SelectOption optionValue="women" optionText="Women" />
            <SelectOption optionValue="unisex" optionText="Unisex" />
            <SelectOption optionValue="pets" optionText="Pets" />
          </SelectInput>
          <SelectInput
            label={"Category"}
            value={category}
            setState={setCategory}
          >
            <SelectOption optionValue="" optionText="Select Category" />
            {catagories?.map((category) => (
              <SelectOption
                optionValue={category._id}
                key={category._id}
                optionText={category?.categoryName}
              />
            ))}
          </SelectInput>
          <SelectInput label={"Brand"} value={brand} setState={setBrand}>
            {/* <SelectOption optionValue='' optionText="Select Brand" /> */}
            {brands?.map((brand) => (
              <SelectOption
                optionValue={brand._id}
                key={brand._id}
                optionText={brand?.name}
              />
            ))}
          </SelectInput>
          <ShortTextInput
            label={`Name`}
            value={name}
            placeholder={`Name`}
            setState={setName}
          />
          <ShortTextInput
            label={`Keywords`}
            value={keywords}
            placeholder={`Keywords`}
            setState={setKeywords}
          />
          <ShortTextInput
            label={`Slug`}
            value={slugify(name)}
            placeholder={`Enter Slug`}
            disabled
          />
          <ShortTextInput
            label={`Price`}
            value={price}
            placeholder={`Price`}
            setState={setPrice}
          />
          <SelectInput label={"Partner"} value={partner} setState={setPartner}>
            {/* <SelectOption optionValue="" optionText="Select Partner" /> */}
            {partners?.map((partner) => (
              <SelectOption
                optionValue={partner._id}
                key={partner._id}
                optionText={partner?.name}
              />
            ))}
          </SelectInput>

          {/* <ShortTextInput
            label={`Description`}
            value={description}
            placeholder={`Description`}
            setState={setDescription}
          /> */}
         <label
            style={{
              display: "block",
              fontWeight: 600,
              fontSize: "1.6rem",
              lineHeight: "2rem",
              color: "#E6E6E6",
              textTransform: "capitalize",
              marginBottom: "1.4rem",
            }}
          >
            Description
          </label>
          <CustomEditor
            data={description}
            setState={setDescription}
            placeholder="Write a short product description…"
          />

          <label
            style={{
              display: "block",
              fontWeight: 600,
              fontSize: "1.6rem",
              lineHeight: "2rem",
              color: "#E6E6E6",
              textTransform: "capitalize",
              marginBottom: "1.4rem",
            }}
          >
            Details
          </label>
          <CustomEditor
            data={details}
            setState={setDetails}
            placeholder="Write a short product details.."
          />

          {/* <CustomEditor 
          setState={setDescription} data={description}
          /> */}

          <SwitchInput
            label={`IsDiscount`}
            toggleSwitch={() => setIsDiscount((prevState) => !prevState)}
            checked={isDiscount}
          />
          {isDiscount && (
            <SelectInput
              label={"Discount"}
              value={discount}
              setState={setDiscount}
            >
              <SelectOption
                optionValue=""
                optionText="Select Discount Percent"
              />
              {discounts?.map((discount) => (
                <SelectOption
                  optionValue={discount._id}
                  key={discount._id}
                  optionText={discount?.percentage}
                />
              ))}
            </SelectInput>
          )}
          
            <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1" style={{ fontWeight: "600", fontSize: "1.6rem", lineHeight: "2rem",
              color: "#E6E6E6", textTransform: "capitalize", marginBottom: "1.4rem"}}>
              Size Guide
            </label>
            <br />

            <input
              type="text"
              placeholder="Search size guide"
              value={sizeGuideSearchTerm}
              onChange={(e) => setSizeGuideSearchTerm(e.target.value)}
              className="w-full px-3 py-2 mb-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              style={{width: "100%", height: "30px", padding: "5px", borderRadius: "5px"}}
            />

            <SelectInput value={sizeGuide} setState={setSizeGuide}>
              <SelectOption optionValue="" optionText="Select Size Guide" />
              {filteredSizeGuides?.map((sg) => (
                <SelectOption
                  optionValue={sg._id}
                  key={sg._id}
                  optionText={sg.name}
                />
              ))}
            </SelectInput>
          </div>

           <SwitchInput
            label={`PreOrder?`}
            toggleSwitch={() => setIsPreOrder((prevState) => !prevState)}
            checked={isPreOrder}
          />
            <SwitchInput
            label={`ReStocked?`}
            toggleSwitch={() => setIsReStocked((prevState) => !prevState)}
            checked={isReStocked}
          />
          <SwitchInput
            label={`Trial Status`}
            toggleSwitch={() => setTrialStatus((prevState) => !prevState)}
            checked={trialStatus}
          />
          <SwitchInput
            label={`Visibility`}
            toggleSwitch={() => setIsVisible((prevState) => !prevState)}
            checked={isVisible}
          />
          <ShortTextInput
            label="Product Group"
            value={productGroup}
            placeholder="Example: TEE001"
            setState={setProductGroup}
          />
          <ShortTextInput
            label="Product Colour Name"
            value={productColorName}
            placeholder="Example: Olivine"
            setState={setProductColorName}
          />

          <ShortTextInput
            label="Product Colour Hex"
            value={productColorHex}
            placeholder="Example: #7F8B72"
            setState={setProductColorHex}
          />
          <ImageInput
            fieldId="1"
            state={cardFrontImage}
            setState={setCardFrontImage}
            allowUpdateImage
          >
            Upload Card Front Image
          </ImageInput>
          <ImageInput
            fieldId="2"
            state={cardHoverImage}
            setState={setCardHoverImage}
            allowUpdateImage
          >
            Upload Card Hover Image
          </ImageInput>
          <ShortTextInput
            label={`Meta Title`}
            value={metaTitle}
            placeholder={`Meta Title`}
            setState={setMetaTitle}
          />
          <ShortTextInput
            label={`Meta Description`}
            value={metaDescription}
            placeholder={`Meta Description`}
            setState={setMetaDescription}
          />
          <NumberInput
            label={"Precedence"}
            placeholder={"Precedence"}
            setState={setPrecedence}
            value={precedence}
          />
        </div>
        <FormSubmitButton text="Update Product" />
      </Form>
    </div>
  );
}

export default UpdateProduct;
